module.exports = __webpack_public_path__ + "img/linkedin-red.67a68fb.svg";